import { SidebarLinkConditional } from '@/types/Sidebar';
import { IconLink } from './IconLink';
import { MAIN_PAGE_LINK_TEXT, SublinksManager } from '../../Sidebar/Sidebar';
import { UserRole } from '@/types/types';
import { ButtonLink } from './ButtonLink';
import { useState } from 'react';
import s from './SidebarRootLink.module.scss';
import { some } from 'lodash';

type SidebarRootLinkProps = SidebarLinkConditional & {
  isExpanded: boolean;
  workspaceRole: UserRole;
  organizationRole: UserRole;
  isOrganizationMember: boolean;
  isDropdownMode?: boolean;
};

export function SidebarRootLink({
  isExpanded,
  workspaceRole,
  isOrganizationMember,
  organizationRole,
  isDropdownMode,
  ...link
}: SidebarRootLinkProps) {
  const [isDropdownActive, setIsDropdownActive] = useState(false);
  return (
    <>
      {isDropdownMode ? (
        <ButtonLink
          disabled={!(link.sublinks && some(link.sublinks, ['disabled', false]))}
          isActive={isDropdownActive}
          setIsActive={setIsDropdownActive}
          additionalTo={link.additionalTo}
          isExpanded={isExpanded}
          icon={link.icon}
          iconAltText={link.altIconText}
          to={link.to}
          end={link.text === MAIN_PAGE_LINK_TEXT}
          tooltip={isExpanded ? undefined : link.text}
        >
          {link.text}
        </ButtonLink>
      ) : (
        <IconLink
          disabled={!(link.sublinks && some(link.sublinks, ['disabled', false]))}
          isExpanded={isExpanded}
          icon={link.icon}
          iconAltText={link.altIconText}
          to={link.to}
          className={s.sidebarLink}
          activeClassName={s.activeLink}
          end={link.text === MAIN_PAGE_LINK_TEXT}
          tooltip={isExpanded ? undefined : link.text}
        >
          {link.text}
        </IconLink>
      )}
      {link.sublinks ? (
        <SublinksManager
          isOrganizationMember={isOrganizationMember}
          organizationRole={organizationRole}
          workspaceRole={workspaceRole}
          isExpanded={isExpanded}
          links={link.sublinks}
          baseLink={link.sublinksRoot ? link.sublinksRoot : link.to}
          isDropDownMode={isDropdownMode}
          isSelected={isDropdownActive}
        />
      ) : null}
    </>
  );
}
